import React from 'react'
import styled from 'styled-components'

type Props = React.HTMLAttributes<HTMLDivElement>

export const TradingPairExploreItemMetricsItem = (props: Props) => {
  return <Item {...props} />
}

const Item = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 3px;

  font-size: 12px;
  font-weight: 500;
  line-height: normal;

  color: var(--text-11);
`

const ItemLabel_ = styled.span`
  color: var(--text-8);
`

TradingPairExploreItemMetricsItem.Label = ItemLabel_
